import ApplePaySuccess from 'features/moveMoney/screens/ApplePay/ApplePaySuccess';
import React from 'react';

export default function ApplePaySuccessPage() {
  return <ApplePaySuccess />;
}
